import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
} from "chart.js";
import { Line } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  ChartDataLabels
);

const CollectionReceivedLineChart = ({
  collectionData = [],
  outstandingData = [],
  showOutstanding = true
}) => {
  /* ================= RESPONSIVE ================= */
  const isMobile = window.innerWidth < 640;

  // ✅ HARD GUARD
  if (!Array.isArray(collectionData) || collectionData.length === 0) {
    return (
      <div
        style={{
          height: 260,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        No data
      </div>
    );
  }

  /* ================= ALIGN MONTHS ================= */
  const labels = collectionData.map(d => d.month);
  const collectionValues = collectionData.map(d =>
    Number(d.amount || 0)
  );
console.log(outstandingData);
  // Map outstanding by month
  const outstandingMap = {};
  outstandingData.forEach(d => {
    outstandingMap[d.month] = Number(d.amount || 0);
  });

  const outstandingValues = labels.map(
    month => outstandingMap[month] || 0
  );
  const salesValues = collectionData.map(d => Number(d.sales || 0));

  /* ================= SCROLL WIDTH ================= */
  const pointWidth = isMobile ? 90 : 100; // per month spacing
  const chartWidth = isMobile
    ? Math.max(labels.length * pointWidth, window.innerWidth)
    : "100%";

  /* ================= CHART DATA ================= */
  const datasets = [
    {
      label: "Collection Received",
      data: collectionValues,
      borderColor: "#d32f2f",
      backgroundColor: "rgba(211,47,47,0.15)",
      fill: true,
      tension: 0.4,
      pointRadius: 4,
      pointHoverRadius: 6,
      datalabels: {
        color: "#2e7d32",
        align: "top",
        anchor: "end",
        offset: 1,
        clip: false,
        font: { weight: "bold", size: 10 },
        formatter: value => `${value.toFixed(2)} L`
      }
    }
  ];

  /*
  if (showOutstanding) {
    datasets.push({
      label: "Outstanding",
      data: outstandingValues,
      borderColor: "#1976d2",
      backgroundColor: "rgba(25,118,210,0.15)",
      fill: true,
      tension: 0.4,
      pointRadius: 4,
      pointHoverRadius: 6,
      datalabels: {
        color: "#1976d2",
        align: "bottom",
        anchor: "start",
        offset: 0,
        clip: false,
        font: { weight: "bold", size: 10 },
        formatter: value => `${value.toFixed(2)} L`
      }
    });
  }
  */

  datasets.push({
    label: "Sales",
    data: salesValues,
    borderColor: "#1976d2",
    backgroundColor: "rgba(25,118,210,0.15)",
    fill: false,
    tension: 0.4,
    pointRadius: 4,
    pointHoverRadius: 6,
    datalabels: {
      color: "#1976d2",
      align: "bottom",
      anchor: "start",
      offset: 0,
      clip: false,
      font: { weight: "bold", size: 10 },
      formatter: value => `${value.toFixed(2)} L`
    }
  });

  const chartData = {
    labels,
    datasets
  };

  /* ================= OPTIONS ================= */
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    layout: {
      padding: { bottom: 30 }
    },
    plugins: {
      legend: {
        display: true,
        position: "top",
        align: "end",
        labels: {
          boxWidth: 14,
          padding: 24,
          font: { size: 11, weight: "500" }
        }
      },
      tooltip: {
        callbacks: {
          label: ctx =>
            `${ctx.dataset.label}: ${ctx.raw.toFixed(2)} L`
        }
      },
      datalabels: {
        clamp: true,
        clip: false
      }
    },
    scales: {
      x: {
        ticks: {
          autoSkip: false,
          maxRotation: isMobile ? 0 : 45,
          minRotation: isMobile ? 0 : 45,
          padding: 10
        }
      },
      y: {
        title: { display: true, text: "Collection Received (LAKH)" },
        beginAtZero: true,
        grace: "20%",
        ticks: {
          callback: value => `${value.toFixed(0)} L`
        }
      }
    }
  };

  return (
    <div style={{ position: "relative" }}>
      {/* SCROLL HINT */}
      {isMobile && (
        <div
          style={{
            fontSize: 11,
            color: "#6b6b8a",
            textAlign: "right",
            marginBottom: 4
          }}
        >
          ← Swipe →
        </div>
      )}

      {/* SCROLLABLE CHART */}
      <div
        style={{
          height: 300,
          position: "relative",
          overflowX: isMobile ? "auto" : "hidden",
          overflowY: "hidden",
          WebkitOverflowScrolling: "touch"
        }}
      >
        <div style={{ width: chartWidth, height: "100%" }}>
          <Line data={chartData} options={options} />
        </div>

        {/* RIGHT FADE INDICATOR */}
        {/* {isMobile && (
          <div
            style={{
              pointerEvents: "none",
              position: "absolute",
              top: 0,
              right: 0,
              width: 36,
              height: "100%",
              background:
                "linear-gradient(to left, rgba(255,255,255,0.95), rgba(255,255,255,0))"
            }}
          />
        )} */}
      </div>
    </div>
  );
};

export default CollectionReceivedLineChart;
